import { Image, Link } from '@src/quince-components/src'
import Swiper, { NAV_POSITION } from '@src/quince-components/src/atoms/swiper/Swiper'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import classNames from 'classnames'

import { getFormattedSlug } from '../../../utils'
import { LinkGroupProps } from '../SubCategoryList'

import styles from './imageSubCategoryList.module.scss'

type TextSubCategoryListProps = LinkGroupProps & {
  sendEventOnButtonClick: (...args: unknown[]) => void
}

function ImageSubCategoryList({ buttons = [], className, sendEventOnButtonClick }: TextSubCategoryListProps) {
  const deviceInfo = useDeviceInfo()
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP

  return (
    <div className={classNames(styles.wrapper, className)}>
      <Swiper
        showDots={false}
        showNavigator={isDesktop}
        numberOfVisibleSlides={9}
        variableWidth
        id={'imageWithProductSlider'}
        isChevronIcon
        navPosition={NAV_POSITION.CENTER}
        prevIconClass={styles.prevArrowClass}
        nextIconClass={styles.nextArrowClass}
        arrowWrapperClass={styles.arrowWrapperClass}
        slideClassName={styles.textSubCategorySlide}
        className={styles.textSubCategorySwiper}
        preventInteractionOnTransition={true}
      >
        {buttons.map((button, index) => {
          const active = index === 0
          return (
            <Link
              key={button.id}
              className={classNames(styles.subCategoryItem, {
                [styles.active]: active,
              })}
              href={active ? undefined : '/' + getFormattedSlug(button.slug)}
            >
              <Image
                alt={button.thumbnailImage?.description}
                url={button.thumbnailImage?.file.url ?? ''}
                title={button.name || ''}
                className={styles.imageWrapper}
                // @i18n-ignore
                loading="eager"
              />
              <div
                className={styles.titleWrapper}
                data-content-type="category-title"
                data-href={button.slug}
                data-active={active}
              >
                <span
                  onClick={() => {
                    sendEventOnButtonClick(button.name, buttons)
                  }}
                  className={styles.imageTitle}
                >
                  {button.name}
                </span>
              </div>
            </Link>
          )
        })}
      </Swiper>
    </div>
  )
}

export default ImageSubCategoryList
